/**
 * CatalogCode Extractor
 *
 * Extracts CatalogCode from the DaVinci BA booking response.
 * Path: bookingResponse.Services[0].Catalogue.Value
 *
 * Used to build SSC GetInsurances request with the correct CatalogCode
 * (e.g., "VR26") from the actual booking context.
 */

export function extractCatalogCodeFromBookingResponse(
  bookingResponse: Record<string, unknown>
): string | null {
  const services = bookingResponse.Services as Array<Record<string, unknown>> | undefined;
  if (!Array.isArray(services) || services.length === 0) return null;

  const firstService = services[0];
  const catalogue = firstService.Catalogue as Record<string, unknown> | undefined;
  if (!catalogue || typeof catalogue.Value !== 'string') return null;

  return catalogue.Value || null;
}
